import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import DeviceNotice from './components/DeviceNotice';
import Home from './pages/Home';
import ReadyChant from './pages/ReadyChant';
import ReadyTap from './pages/ReadyTap';
import TimerTap from './pages/TimerTap';
import TimerChant from './pages/TimerChant';
import Countdown from './pages/Countdown';
import TryAgainChant from './pages/TryAgainChant';
import TryAgainTap from './pages/TryAgainTap';
import Success from './pages/Success';
import Redeem from './pages/Redeem';
import OnboardingChant from './pages/OnboardingChant';
import OnboardingTap from './pages/OnboardingTap';
import CodeNotWorking from './pages/CodeNotWorking';
import CountdownTap from './pages/CountdownTap';

const StyledApp = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 58px 16px 0;
  background: #FFFFFF;
  box-sizing: border-box;
  min-height: 100vh;
  transition: opacity .25s;
  overflow-x: hidden;
`;

function App() {
  const [page, setCurrentPage] = useState('home');
  const [transitioning, setTransitioning] = useState(false);
  const [score, setScore] = useState(0);
  const [prizeCode, setPrizeCode] = useState(false);
  const [attemptCount, setAttemptCount] = useState(0);
  const [timer, setTimer] = useState(0);
  const [tapOptions, setTapOptions] = useState([]);
  const [tapPhrase, setTapPhrase] = useState('');
  const correctPhrase = 'Two all-beef patties, special sauce, lettuce, cheese, pickles, onions on a sesame seed bun.';
  const [isPortrait, setIsPortrait] = useState(null);
  const [isReopeningSocket, setIsReopeningSocket] = useState(false);

  useEffect(() => {
    const allImages = require.context(
      "./assets/img/",
      false,
      /\.(png|svg)$/
    );
    allImages.keys().forEach(item => {
      const importedImg = allImages(item); // import image
      const img = new Image();
      img.src = importedImg;
    });
  }, []);
  
  const setPage = (page)  => {
    setTransitioning(true);
    
    setTimeout(() => {
      setCurrentPage(page)
      setTransitioning(false);
    }, 100);
  }

  const setCurrentScore = currScore => {
    if (page === 'timer-chant') {
      setScore(prev => currScore > prev ? currScore : prev);
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    }

    window.addEventListener('resize', handleResize);

    handleResize();
  }, [isPortrait]);

  return (
    <>
      { isPortrait !== null && isPortrait && (
        <StyledApp style={{"opacity": transitioning ? 0 : 1}}>
          { page === 'home' && <Home setPage={setPage}/> }
          { page === 'ready-chant' && <ReadyChant setPage={setPage} setScore={setScore} score={score} setIsReopeningSocket={setIsReopeningSocket} attemptCount={attemptCount}/> }
          { page === 'onboarding-chant' && <OnboardingChant setPage={setPage} /> }
          { page === 'ready-tap' && <ReadyTap setPage={setPage}/> }
          { page === 'onboarding-tap' && <OnboardingTap setPage={setPage} /> }
          { page === 'countdown' && <Countdown setPage={setPage}/> }
          { page === 'timer-chant' && <TimerChant page={page} setPage={setPage} timer={timer} setTimer={setTimer} attemptCount={attemptCount} setAttemptCount={setAttemptCount} score={score} setScore={setCurrentScore}/> }
          { page === 'timer-tap' && <TimerTap setPage={setPage} timer={timer} setTimer={setTimer} correctPhrase={correctPhrase} setTapOptions={setTapOptions} tapPhrase={tapPhrase} setTapPhrase={setTapPhrase} attemptCount={attemptCount} setAttemptCount={setAttemptCount}/> }
          { page === 'countdown-tap' && <CountdownTap setPage={setPage}/> }
          { page === 'try-again-tap' && <TryAgainTap setPage={setPage} setTimer={setTimer} tapOptions={tapOptions} setTapOptions={setTapOptions} setTapPhrase={setTapPhrase} setAttemptCount={setAttemptCount}/> }
          { page === 'try-again-chant' && <TryAgainChant setPage={setPage} setTimer={setTimer} tapOptions={tapOptions} setTapOptions={setTapOptions} setTapPhrase={setTapPhrase} setAttemptCount={setAttemptCount} isReopeningSocket={isReopeningSocket} setIsReopeningSocket={setIsReopeningSocket}/> }
          { page === 'success' && <Success setPage={setPage} prizeCode={prizeCode} setPrizeCode={setPrizeCode} attemptCount={attemptCount} tapPhrase={tapPhrase} score={score} correctPhrase={correctPhrase}/> }
          { page === 'redeem' && <Redeem setPage={setPage} prizeCode={prizeCode}/> }
          { page === 'code-not-working' && <CodeNotWorking setPage={setPage} prizeCode={prizeCode}/> }
        </StyledApp>
      ) }
      { isPortrait !== null && !isPortrait && (
        <DeviceNotice/>
      ) }
    </>
  );
}

export default App;
